import { ShelfElement } from './shelf-element';


export const SHELF_ELEMENTS: ShelfElement[] = [
        {
            id: 1,
            name: 'Bodenmodul',
            articleNumber: 'KKL0001',
            length: 56.15,
            width: 34,
            height: 26.7,
            model3d: 'sockelmodul.dae',
            image: 'assets/images/KKL0001.GIF',
            isFloorElement: true,
            isEdgeElement: false,
            isTopElement: false,
            group: 'floor'
        },
        {
            id: 18,
            name: 'Bodenmodul mit Normteilefach',
            articleNumber: 'KKL0018',
            length: 56.15,
            width: 34,
            height: 26.7,
            model3d: 'sockelmodul_fach.dae',
            image: 'assets/images/KKL0018.GIF',
            isFloorElement: true,
            isEdgeElement: false,
            isTopElement: false,
            group: 'floor',
        },
        {
            id: 2,
            name: 'Abschlussmodul',
            articleNumber: 'KKL0002',
            length: 56.15,
            width: 34,
            height: 14.7,
            model3d: 'deckelmodul.dae',
            image: 'assets/images/KKL0002.GIF',
            isFloorElement: false,
            isEdgeElement: false,
            isTopElement: true,
            group: 'closing'

        },
        {
            id: 3,
            name: 'Normteilemodul 3-fach',
            articleNumber: 'KKL0003',
            length: 56.15,
            width: 34,
            height: 44.4,
            model3d: 'normteilemodul.dae',
            image: 'assets/images/KKL0003.GIF',
            isFloorElement: false,
            isEdgeElement: false,
            isTopElement: false,
            group: 'norm'
        },
        {
            id: 4,
            name: 'Normteilemodul 9-fach',
            articleNumber: 'KKL0004',
            length: 56.15,
            width: 34,
            height: 134.2,
            model3d: 'normteilemodul_9fach.dae',
            image: 'assets/images/KKL0004.GIF',
            isFloorElement: false,
            isEdgeElement: false,
            isTopElement: false,
            group: 'norm'
        },
        {
            id: 5,
            name: 'Universalmodul 1-fach',
            articleNumber: 'KKL0005',
            length: 56.15,
            width: 34,
            height: 44.4,
            model3d: 'universalbodenmodul.dae',
            image: 'assets/images/KKL0005.GIF',
            isFloorElement: false,
            isEdgeElement: false,
            isTopElement: false,
            group: 'universal'
        },
    {
        id: 6,
        name: 'Universalmodul 2-fach',
        articleNumber: 'KKL0006',
        length: 56.15,
        width: 34,
        height: 44.4,
        model3d: 'uni_bodenmodul_2fach.dae',
        image: 'assets/images/KKL0005.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'universal'
    },
    {
        id: 7,
        name: 'Wannenmodul 1-fach (3 Trenner)',
        articleNumber: 'KKL0007',
        length: 56.15,
        width: 34,
        height: 44.4,
        model3d: 'wannenmodul.dae',
        image: 'assets/images/KKL0007.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'trough'
    },
    {
        id: 8,
        name: 'Wannenmodul 2-fach (3 Trenner)',
        articleNumber: 'KKL0008',
        length: 56.15,
        width: 34,
        height: 44.4,
        model3d: 'wannenmodul_2fach.dae',
        image: 'assets/images/KKL0008.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'trough'
    },
    {
        id: 9,
        name: 'Chemiemodul 1-fach (5 Trenner)',
        articleNumber: 'KKL0009',
        length: 56.15,
        width: 34,
        height: 44.4,
        model3d: 'chemiemodul.dae',
        image: 'assets/images/KKL0009.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'chemical'
    },
    {
        id: 10,
        name: 'Chemiemodul 2-fach (5 Trenner)',
        articleNumber: 'KKL00010',
        length: 56.15,
        width: 34,
        height: 44.4,
        model3d: 'chemiemodul_2fach.dae',
        image: 'assets/images/KKL0010.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'chemical'
    },
    {
        id: 11,
        name: 'Schubladenmodul',
        articleNumber: 'KKL00011',
        length: 56.15,
        width: 34,
        height: 44.4,
        model3d: 'schubladenmodul.dae',
        image: 'assets/images/KKL0011.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'drawer'
    },
    {
        id: 12,
        name: 'Schuladenmodul 12-fach (Sonderartikel)',
        articleNumber: 'KKL00012',
        length: 56.15,
        width: 34,
        height: 89.3,
        model3d: 'schubladenmodul_12fach.dae',
        image: 'assets/images/KKL0012.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'drawer'
    },
    {
        id: 13,
        name: 'Trennscheibenmodul',
        articleNumber: 'KKL00013',
        length: 56.15,
        width: 34,
        height: 44.4,
        model3d: 'trennscheibenmodul.dae',
        image: 'assets/images/KKL0013.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'others'
    },
    {
        id: 14,
        name: 'Gewindestangenmodul',
        articleNumber: 'KKL00014',
        length: 56.15,
        width: 34,
        height: 102.3,
        model3d: 'stangenmodul.dae',
        image: 'assets/images/KKL0014.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'others'
    },
    {
        id: 19,
        name: 'Schrankmodul, absperrbar',
        articleNumber: 'KKL00019',
        length: 56.15,
        width: 34,
        height: 102.3,
        model3d: 'schrankmodul.dae',
        image: 'assets/images/KKL0019.GIF',
        isFloorElement: false,
        isEdgeElement: false,
        isTopElement: false,
        group: 'others'
    },
    {
        id: 15,
        name: 'Bodeneckmodul',
        articleNumber: 'KKL00015',
        length: 62.30,
        width: 62.30,
        height: 26.70,
        model3d: 'sockelmodul_ecke.dae',
        image: 'assets/images/KKL0015.GIF',
        isFloorElement: true,
        isEdgeElement: true,
        isTopElement: false,
        group: 'edge'
    },
    {
        id: 16,
        name: 'Universaleckmodul',
        articleNumber: 'KKL00016',
        length: 62.30,
        width: 62.30,
        height: 44.40,
        model3d: 'uni_bodenmodul_ecke.dae',
        image: 'assets/images/KKL0016.GIF',
        isFloorElement: false,
        isEdgeElement: true,
        isTopElement: false,
        group: 'edge'
    },
    {
        id: 17,
        name: 'Abschlusseckmodul',
        articleNumber: 'KKL00017',
        length: 62.30,
        width: 62.30,
        height: 14.70,
        model3d: 'deckelmodul_ecke.dae',
        image: 'assets/images/KKL0017.GIF',
        isFloorElement: false,
        isEdgeElement: true,
        isTopElement: true,
        group: 'edge'
    }
    ];




// WEBPACK FOOTER //
// ./src/app/shelf-elements.ts